import {totalSpent} from 'core/LifeCycle';
import {useBudgetStore} from 'store/Budget';
import {useHistoryStore} from 'store/History';

export function useSpentTotal(): number {
  const budget = useBudgetStore();
  const history = useHistoryStore();
  return totalSpent(budget, history);
}
